/**
 * Generated by orval v6.20.0 🍺
 * Do not edit manually.
 * portrich-api
 * OpenAPI spec version: 0.0.0
 */

export type ShipmentsListTransportationProgress = typeof ShipmentsListTransportationProgress[keyof typeof ShipmentsListTransportationProgress];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShipmentsListTransportationProgress = {
  NUMBER_0: 0,
  NUMBER_1: 1,
  NUMBER_2: 2,
} as const;
